import {
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';

const useContinuousRefetch = ({
  refetchFrequency = 500,
  refetchDuration = 5000,
}: {
  refetchFrequency?: number;
  refetchDuration?: number;
} = {}) => {
  const [refetchInterval, setRefetchInterval] = useState<number | false>(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  const refetch = useCallback(() => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    setRefetchInterval(refetchFrequency);
    timeoutRef.current = setTimeout(() => {
      setRefetchInterval(false);
      timeoutRef.current = null;
    }, refetchDuration);
  }, [refetchDuration, refetchFrequency]);

  useEffect(() => () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
  }, []);

  return { refetchInterval, refetch };
};

export default useContinuousRefetch;
